import { useEffect, useState } from "react";
import ResponsiveAppBar from "../../../../layouts/navbar";
import { Footer } from "../../../../layouts/footer";
import { useAppSelector } from "../../../../../app/redux/hooks";

export const PrivactPolicy = () => {
  const privacy = useAppSelector((state) => state.FooterDataState.aboutUs);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <ResponsiveAppBar />
      <div
        id="wrapper"
        style={{
          fontFamily: "Albert Sans, sans-serif",
          fontSize: "14px",
          lineHeight: "22px",
          fontWeight: "400",
        }}
      >
        <div className="tf-page-title style-3">
          <div className="container-full">
            <div className="heading text-center">Privacy Policy</div>
          </div>
        </div>
        <section className="flat-spacing-9">
          <div className="container">
            <div className="row">
              <div className="col-12">
                {/* <img
                  src="images/policy.png"
                  width="500"
                  style={{ float: "left" }}
                  className="me-5 mb-5 img-fluid"
                  alt=""
                /> */}

                {/* <p className="mb-3">{privacy?.data?.data?.privacy}</p> */}
                <div
                  dangerouslySetInnerHTML={{
                    __html: privacy?.data?.data?.privacy,
                  }}
                />
              </div>
            </div>
          </div>
        </section>
        <Footer />
      </div>
    </>
  );
};
